export default class Camera {
    static defaultFormat = 'image/png';

    constructor(previewElement, constraints = {video: true}) {
        this.previewElement = previewElement;
        this.constraints = constraints;
    }

    async load(autoPlay = true) {
        this.userMedia = this.userMedia || Camera.getUserMedia();
        if (!this.userMedia) {
            throw new Error('No user media detected');
        }
        const stream = await this.userMedia(this.constraints);
        if ('srcObject' in this.previewElement) {
            this.previewElement.srcObject = stream;
        } else {
            this.previewElement.src = window.URL.createObjectURL(stream);
        }
        if (autoPlay) {
            this.previewElement.onloadedmetadata = this.play.bind(this);
        }
    }

    capture() {
        if (!this.isPlay) {
            return false;
        }
        const canvas = document.createElement('canvas');
        canvas.width = this.previewElement.videoWidth;
        canvas.height = this.previewElement.videoHeight;
        canvas.getContext('2d').drawImage(this.previewElement, 0, 0);
        return canvas.toDataURL(Camera.defaultFormat);
    }

    play() {
        if (!this.previewElement.play || this.isPlay) {
            return;
        }
        this.previewElement.play();
        this.isPlay = true;
    }

    pause() {
        if (!this.previewElement.pause || !this.isPlay) {
            return;
        }
        this.previewElement.pause();
        this.isPlay = false;
    }

    static getUserMedia() {
        if (navigator.mediaDevices.getUserMedia) {
            return navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        }
        const userMedia = navigator.getUserMedia
            || navigator.webkitGetUserMedia
            || navigator.mozGetUserMedia;
        if (userMedia) {
            return (constraints) => {
                const executor = (resolve, reject) => userMedia
                    .call(navigator, constraints, resolve, reject);
                return new Promise(executor);
            };
        }
        return false;
    }

    static get isAvailable() {
        return this.getUserMedia() !== false;
    }

    static dataUrlToBlob(dataURL) {
        const blobBin = atob(dataURL.split(',')[1]);
        const array = [];
        for (let i = 0; i < blobBin.length; i += 1) {
            array.push(blobBin.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {type: this.defaultFormat});
    }
}
